import { useState } from "react";

const useForm = (initialState = {}) => {
  const [dataForm, setDatosFormulario] = useState(initialState);

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setDatosFormulario((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  return { dataForm, handleChange };
};

export default useForm;
